import React from 'react';
import MoodIcon from '@mui/icons-material/Mood';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const green = '#4caf50';
const orange = '#ff9800';
const red = '#f44336';

export const getRates = rates => {
    const model = rates?.model;
    if (!rates || !model) return 'noRates';
    if (model === 1) return rates.occupancies || 'noRates';
    if (model === 2) return rates.room || 'noRates';
    if (model === 3) return rates.persons.rates || 'noRates';
};

const iconStyle = {
    boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)', // Sombra negra con opacidad del 50%
    borderRadius: '50%', // Esto redondea el icono
};

export const getQualityStatus = (validity, quality) => {
    const qualities = {
        0: {
            icon: <MoodIcon style={{ color: green, ...iconStyle }} />,
            reason: 'high_quality_reason',
            text: 'high_quality',
        },
        1: {
            icon: (
                <SentimentNeutralIcon style={{ color: orange, ...iconStyle }} />
            ),
            reason: 'medium_quality_reason',
            text: 'medium_quality',
        },
        2: {
            icon: (
                <SentimentVeryDissatisfiedIcon
                    style={{ color: red, ...iconStyle }}
                />
            ),
            reason: 'low_quality_reason',
            text: 'low_quality',
        },
        3: {
            icon: <WarningAmberIcon style={{ color: red, ...iconStyle }} />,
            text: 'invalid_quality',
        },
    };

    const { valid } = validity;
    if (valid) {
        const { level } = quality;
        return qualities[level];
    } else {
        return qualities[3];
    }
};
